export default {
    titulo: "Servicios",
    nuevo: "Nuevo servicio",
    busqueda: "Buscar por número de orden, equipo, nombre de cliente o problema",
    hayPlural: "Hay",
    haySingular: "Hay",
    textAgendadosPlural: "Servicios agendados para el",
    textAgendadosSingular: "Servicio agendado para el",
    errorApertura: "Debe realizar la apertura del servicio",
    tipo: "Tipo de servicio",
    pregEliminar: "¿Confirmas que deseas eliminar la orden de servicio?",
    eliminarPrev: "Eliminar servicio preventivo",
    pregEliminarPrev: "¿Confirmas que deseas eliminar el servicio preventivo?",
    estaPrev: "Eliminar sólo esta orden",
    todasPrev: "Esta órden y todas las relacionadas",
    futurasPrev: "Esta órden y las futuras relacionadas",
    msgErrorPlan: "Tu plan de SatWeb no incluye la funcionalidad de Servicios. Para utilizarla debes suscribirte a otro plan",
    grados: {
        Normal: "Normal",
        Urgente: "Urgente",
        Emergencia: "Emergencia"
    },
    tipos: {
        Correctivo: "Correctivo",
        Preventivo: "Preventivo",
        Predictivo: "Predictivo",
        Mejorativo: "Mejorativo",
        Instalacion: "Instalación" 
    },
    tituloVerOrden: "Orden de Servicio ",
    informeMantencion: "Informe de mantención",
    gestion: "Indicadores de gestión",
    finalizar: "Finalizar",
    iniciar: "Iniciar",
    detener: "Detener orden",
    reanudar: "Reanudar orden",
    pregDetener: "¿Confirmas que deseas detener la orden?",
    motivo: "Indique el motivo",
    pregReanudar: "¿Confirmas que deseas reanudar la orden?",
    pregIniciar: "¿Confirmas que deseas iniciar la apertura de la orden?",
    pregFinalizar: "¿Confirmas que deseas finalizar la orden de servicio?",
    hora: "Hora",
    imprimirFinalizada: "Imprimir reporte de orden finalizada",
    solicitud: "Solicitud",
    inicio: "Inicio ruta",
    apertura: "Apertura",
    detectada: "Falla detectada",
    reparada: "Falla reparada",
    finalizacion: "Finalización",
    detenido: "Detenido",
    total: "Atención total",
    msgPin: "Se necesita el pin del cliente para iniciar la apertura del servicio",
    textSeleccionarCliente: "Selecciona una opción para ingresar los datos de un cliente.",
    registrarCliente: "Registrar un nuevo cliente",
    buscarCliente: "Buscar un cliente registrado",
    detallesCliente: "Detalles del cliente",
    noDataCliente: "No se ha seleccionado ningún cliente",
    textOrdenSinEquipo: "Activa esta opción si la orden no tiene un equipo asociado",
    registrarEquipo: "Registrar un nuevo equipo",
    buscarEquipo: "Buscar un equipo registrado",
    detallesEquipo: "Detalles del equipo",
    noDataEquipo: "No se ha seleccionado ningún equipo",
    siniestro: "Orden con siniestro",
    planMantenimiento: "Plan de mantenimiento",
    repetir: "Repetir",
    noRepetir: "No repetir",
    categoria: "Categoría",
    nroManual: "Número de orden manual",
    asignacion: "Asignación de técnico",
    msgAsignacion: "Si asignas la orden de servicio a otra persona se te avisará para que estés al tanto de la nueva tarea que tiene que efectuar",
    usuario: "Usuario",
    grupo: "Grupo",
    frecuencia: "Frecuencia", 
    repetirCada: "Repetir cada",
    msgFechaInvalida: "Debe ser mayor o igual que la fecha de inicio",
    dia: "Día",
    dias: "Días",
    mes: "Mes",
    meses: "Meses",
    msgStep1: "Para continuar con el servicio debes seleccionar un Cliente",
    msgStep2: "Para continuar con el servicio debes seleccionar un Equipo",
    msgStep3: "Para continuar con el servicio debes escribir algún problema del equipo",
    msgStep4: "Para continuar debes seleccionar un técnico.",
    cada: "Cada",
    desde: "desde",
    hasta: "hasta",
    ingreso: "Ingreso",
    verRegistros: "Ver registros de la orden",
    tituloRegistros: "Registros de la orden de servicio",
    estados: {
        "Sin Realizar": "Sin Realizar",
        "En Proceso": "En Proceso",
        "Realizado": "Realizado"
    },
    personaContacto: "Persona de contacto",
    asociarEquipo: "Asociar equipo a la orden",
    msgNoHayPermiso: "No tiene permiso para modificar esta orden",
    problema: "Problema reportado",
    editarProblema: "Modificar problema reportado",
    reagendar: "Reagendar",
    fechaReclamo: "Fecha de Reclamo",
    sucursalReclamo: "Sucursal reclamada",
    deptoReclamo: "Departamento reclamado",
    gradoReclamo: "Grado reclamado",
    estadosReclamo: "Estados del reclamo",
    textInforme: "Ingresa el informe de la orden",
    nuevaNota: "Nueva nota",
    eliminarNota: "Eliminar nota",
    pregEliminarNota: "¿Confirmas que deseas eliminar esta nota?",
    presupuesto: {
        manoObra: "Mano de obra",
        repuestos: "Repuestos",
        entrega: "Entrega a cuenta",
        impuestos: "Impuestos",
        total: "Total del presupuesto",
        email: "Enviar por Email",
        wpp: "Enviar por Whatsapp",
    },
    convertirReclamo: "Generando orden de servicio correctiva a partir de reclamo #",
    equipoIngresado: "Equipo ingresado por el cliente",
    usarEquipo: "Usar este equipo",
    eliminarReclamo: "¿Confirmas que deseas eliminar el reclamo?"
}